import apiHub from "./apiHub";

export async function getAboutKerala() {
  // console.log("getAboutKerala called");
  return await apiHub.get("/about-kerala");
}
